
export const SITE_CONFIG = {
  name: "Spot Formation",
  description: "Boostez votre réussite avec Spot Formation. Nos programmes de formation et d'accompagnement sur mesure pour entrepreneurs vous aident à concrétiser vos projets.",
  url: "https://spot-formation.vercel.app",
  ogImage: "https://spot-formation.vercel.app/og.png",
  links: {
    twitter: "https://twitter.com/spotformation",
    github: "https://github.com/spotformation",
  },
};


